module.exports = __webpack_public_path__ + "img/zhongwen.e5c44f05.png";